//Button Addon
export const BUTTON_ADDON = [
  {
    text: "Multiple add-ons are supported and can be mixed with buttons input versions.",
  },
];

//Custom Form
export const CUSTOM_FORMS = [
  {
    text: "Input groups include support for ",
    code: "custom selects and custom file inputs",
  },
  {
    text: ". Browser default versions of these are not supported.",
  },
];

export const PIXEL_DATA = ["Tivo", "Cuba", "Roxo"];

export const COLOR_DATA = ["Yellow", "Red", "Orange"];

export const CHOCOLATE_DATA = ["Dark Chocolates", "Dairy Milk", "Kitkat"];

export const FAVORATE_THEME_DATA = ["Oslo", "Koho", "Voxo"];

//Custom File Input
export const CUSTOM_FILE_INPUT = [
  {
    text: "Input groups include support for custom selects and custom ",
    code: "file uploads",
  },
  {
    text: ". Browser default versions of these are not supported.",
  },
];

//Buttons With Dropdown
export const BUTTON_WITH_DROPDOWN = [
  {
    text: "Use the",
    code: ".input-group ",
  },
  {
    text: "and ",
    code: "[aria-label='']",
  },
  {
    text: " through buttons with dropdowns",
  },
];

export const BUTTON_WITH_DROPDOWN_1 = ["Ecommerce", "Email", "Users", "Bookmarks"];

export const BUTTON_WITH_DROPDOWN_2 = ["Starter kit", "Gallery", "Blog", "Maps"];

export const BUTTON_WITH_DROPDOWN_3 = ["Widgets", "Project", "Contacts", "Tasks"];

export const BUTTON_WITH_DROPDOWN_4 = ["To-Do", "FAQ", "Knowledgebase", "Support Ticket"];

//Segmented Button
export const SEGMENT_BUTTON = [
  {
    text: "Multiple add-ons are supported and can be mixed with",
    code: " dropdowns",
  },
  {
    text: " versions.",
  },
];

export const SEGMENT_DATA_1 = ["Learning", "Editors", "Users", "Social App"];

export const SEGMENT_DATA_2 = ["Search Result", "Tasks", "Projects", "Animation"];

//Checkboxes And Radios
export const CHECH_AND_RADIO_BUTTON = [
  {
    text: "Place any checkbox or radio option within an input group's addon instead of text. We recommend adding ",
    code: ".mt-0",
  },
  {
    text: " to the ",
    code: ".form-check-input",
  },
  {
    text: " when there's no visible text next to the input.",
  },
];

//Sizing
export const SIZING_DATA = [
  {
    text: "Add the relative form sizing classes to the",
    code: " .input-group",
  },
  {
    text: " itself and contents within will automatically resize—no need for repeating the form control size classes on each element.",
  },
];

//Multiple Input
export const MULTIPLE_INPUT_DATA = [
  {
    text: "While multiple ",
    code: "<input>",
  },
  {
    text: " itself and contents within will automatically resize—no need for repeating the form control size classes on each element.",
    code: "<input>.",
  },
];

//BasicInput Groups
export const BASIC_INPUT_GROUP = [
  {
    text: "lace one add-on or button on either side of an input. You may also place one on both sides of an input. Remember to place ",
    code: "<label>",
  },
  {
    text: "s outside the input group.",
  },
];

//Variation of addons
export const VARIATION_OF_ADDONS = [
    {
      text: "Place one add-on or button on either side of an input. You may also place one on both sides of an input. Remember to place ",
      code: "<label>",
    },
    {
      text: "s outside the input group.",
    },
  ];